var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var gauge_exports = {};
__export(gauge_exports, {
  Gauge: () => Gauge
});
module.exports = __toCommonJS(gauge_exports);
var import_counter = require("./counter");
class Gauge extends import_counter.Counter {
  dec(labels) {
    const metric = this.get(labels);
    this.set(metric ? metric.value - 1 : 0, labels);
    return this;
  }
  sub(amount, labels) {
    const metric = this.get(labels);
    this.set(metric ? metric.value - amount : 0, labels);
    return this;
  }
}
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vc3JjL2dhdWdlLnRzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyJpbXBvcnQgeyBMYWJlbHMgfSBmcm9tIFwiLi90eXBlc1wiO1xuaW1wb3J0IHsgQ291bnRlciB9IGZyb20gXCIuL2NvdW50ZXJcIjtcblxuZXhwb3J0IGNsYXNzIEdhdWdlIGV4dGVuZHMgQ291bnRlciB7XG4gIGRlYyhsYWJlbHM/OiBMYWJlbHMpOiB0aGlzIHtcbiAgICBjb25zdCBtZXRyaWMgPSB0aGlzLmdldChsYWJlbHMpO1xuICAgIHRoaXMuc2V0KG1ldHJpYyA/IG1ldHJpYy52YWx1ZSAtIDEgOiAwLCBsYWJlbHMpO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgc3ViKGFtb3VudDogbnVtYmVyLCBsYWJlbHM/OiBMYWJlbHMpOiB0aGlzIHtcbiAgICBjb25zdCBtZXRyaWMgPSB0aGlzLmdldChsYWJlbHMpO1xuICAgIHRoaXMuc2V0KG1ldHJpYyA/IG1ldHJpYy52YWx1ZSAtIGFtb3VudCA6IDAsIGxhYmVscyk7XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cbn1cbiJdLAogICJtYXBwaW5ncyI6ICI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUNBLHFCQUF3QjtBQUVqQixNQUFNLGNBQWMsdUJBQVE7QUFBQSxFQUNqQyxJQUFJLFFBQXVCO0FBQ3pCLFVBQU0sU0FBUyxLQUFLLElBQUksTUFBTTtBQUM5QixTQUFLLElBQUksU0FBUyxPQUFPLFFBQVEsSUFBSSxHQUFHLE1BQU07QUFDOUMsV0FBTztBQUFBLEVBQ1Q7QUFBQSxFQUVBLElBQUksUUFBZ0IsUUFBdUI7QUFDekMsVUFBTSxTQUFTLEtBQUssSUFBSSxNQUFNO0FBQzlCLFNBQUssSUFBSSxTQUFTLE9BQU8sUUFBUSxTQUFTLEdBQUcsTUFBTTtBQUNuRCxXQUFPO0FBQUEsRUFDVDtBQUNGOyIsCiAgIm5hbWVzIjogW10KfQo=
